<template>
  <hawk-iframe path="report/view"></hawk-iframe>
</template>
<script>

import HawkIframe from '@/components/HawkIframe.vue';

export default {
  name: 'hawk-report',
  components: {
    HawkIframe,
  },
  mounted() {
    this.$store.dispatch('SET_FULL_PAGE', true);
  },
  beforeDestroy() {
    this.$store.dispatch('SET_FULL_PAGE', false);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/hawk/Report.vue